import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { Link } from 'components/Link/Link';

export const P = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 175%;
  color: ${Colors.grey700};
`;

export const TABLE = styled.table`
  border: 1px solid ${Colors.grey200};
  border-collapse: collapse;
  display: block;
  width: 100%;

  ${mediaQueries.tablet} {
    display: table;
  }
`;

export const TH = styled.th`
  background-color: ${Colors.grey100};
  display: block;
  padding: 15px 10px;
  text-align: left;

  P {
    color: ${Colors.black};
    font-weight: 600;
  }

  ${mediaQueries.tablet} {
    display: table-cell;
  }
`;

export const TR = styled.tr`
  display: block;

  ${mediaQueries.tablet} {
    display: table-row;
  }
`;

export const TD = styled.td<{ columnIndex: number; content: string }>`
  display: block;
  position: relative;
  padding-left: 50%;

  &:before {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }

  &:nth-of-type(${(props) => props.columnIndex + 1}):before {
    font-weight: 600;
    content: '${(props) => props.content}';
  }

  ${mediaQueries.tablet} {
    display: table-cell;
    position: initial;
    padding-left: initial;

    &:nth-of-type(${(props) => props.columnIndex + 1}):before {
      content: '';
    }

    &:first-child {
      padding-left: 15px;
    }

    &:last-child {
      padding-right: 15px;
    }

    &:before {
      position: initial;
      top: initial;
      left: initial;
      width: initial;
      padding-right: initial;
      white-space: initial;
    }
  }
`;

export const TBODY = styled.tbody`
  display: block;

  TR {
    border-bottom: 1px solid ${Colors.grey200};

    &:hover,
    &:nth-of-type(odd) {
      background-color: ${Colors.grey000};
    }

    TD {
      padding-bottom: 10px;
      padding-top: 10px;
      vertical-align: top;
      ${mediaQueries.tablet} {
        padding: 10px;
      }
    }
  }

  ${mediaQueries.tablet} {
    display: table-row-group;

    TR {
      &:hover {
        background-color: ${Colors.grey000};
      }

      &:nth-of-type(odd) {
        background-color: ${Colors.white};

        &:hover {
          background-color: ${Colors.grey000};
        }
      }

      &:first-child {
        P {
          &:first-child {
            padding-top: 15px;
          }
        }

        &:last-child {
          P {
            &:last-child {
              padding-bottom: 15px;
            }
          }
        }
      }
    }
  }
`;

export const THEAD = styled.thead`
  display: block;

  TR {
    position: absolute;
    left: -9999px;
    top: -9999px;
  }

  ${mediaQueries.tablet} {
    display: table-header-group;

    TR {
      position: initial;
      top: initial;
      left: initial;
    }
  }
`;

export const LI = styled.li`
  display: list-item;
`;

export const UL = styled.ul`
  list-style: disc;
  margin-left: 10px;
  padding-left: 10px;
`;

export const A = styled(Link)`
  color: ${Colors.blue500};
`;

export const IMG = styled.img`
  height: auto;
  width: 100%;
  max-width: 40px;
`;

export const BOLD = styled.strong``;
